import React, { Component } from "react";
import { MainProvider } from "./Context/MainContext/MainContext";
import MainContext from "./Context/MainContext/MainContext";
import moment from "moment-timezone";
import { withRouter } from "react-router-dom";

import Routes from "./Routes";
import Setting from "./Utility/Setting";
import PODeliveryUpdate from "./Seating/PurchaseQueue/PODeliveryUpdate";
import InventoryRequest from "./Seating/PurchaseQueue/inventoryRequest";
import background from "./Asset/Image/background.jpg";
// MDB Shims
import MDBModal from "./Component/MDBShim/MDBModal";

import "./index.css";
import MUISnackbar from "@mui/material/Snackbar";
import MUIAlert from "@mui/material/Alert";
import MUIButton from "@mui/material/Button";
import { SnackbarProvider as NotistackSnackbarProvider } from "notistack";
import { AdapterMoment as MUIAdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider as MUILocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AppBar from "./Component/AppBar";

class App extends Component {
  static contextType = MainContext; // For legacy class components

  constructor(props) {
    super(props);

    this.state = {
      pca: null,
      collapseID: "",
      navigationOpen: false,
      allThemes: [
        "Gorgeous Contrast",
        "Alternate Contrast",
        "Corporate",
        "Bold",
        "Plum",
        "Indigo",
        "Umber",
      ],
      currentUser: {},
      company: "",
      companyName: "",
      poDeliveryUpdate: false,
      inventoryRequestOpen: false,
      insuranceTypes: [],
      insuranceSubTypes: [],
      productTypes: [],
      productSubTypes: [],
      searchText: "",
      reasons: [],
      therapists: [],
      salesReps: [],
      accounts: [],
      myAccounts: [],
      allLocations: [],
      allRegions: [],
      allUsers: [],
      userRefs: [],
      allActiveUsers: [],
      allLiaisons: [],
      allPCR: [],
      allAtp: [],
      thirdPartyUsers: [],
      thirdPartyUsersLoaded: false,
      cardTypes: [],
      expenseTypes: [],
      documentTypes: [],
      contactTypes: [],
      accountTypes: [],
      patientCommunicationTriggerDefs: [],
      techs: [],
      marketingCampaigns: [],
      complaintCategories: [],
      complaintReasons: [],
      allVendors: [],
      allBaseUnits: [],
      allBaseUnitTypes: [],
      productOverrides: [],
      orderModalOpen: false,
      orderErrorMessage: "",
      orderFound: false,
      orderId: "",
      stateSalesTax: [],
      updateNotesModalOpen: false,
      queueRouteTriggers: [
        {
          value: "addPartAndAuthorization",
          name: "Add part and approve ticket",
          description:
            "Adds an appropriate service part, approves that part, and approves the ticket",
        },
        {
          value: "addApprovedPart",
          name: "Add part and do not approve ticket",
          description:
            "Adds an appropriate service part, approves that part, and does not approve the ticket",
        },
        {
          value: "addFollowupDate",
          name: "Set Followup Date",
          description:
            "Sets a new followup date according to predefined rules.",
        },
        {
          value: "toggleCreateNoteModal",
          name: "Require note",
          description: "Requires adding a note",
        },
        {
          value: "toggleAuthNoteModal",
          name: "Require auth note",
          description: "Requires adding an auth note",
        },
        {
          value: "createApprovalNote",
          name: "Approve",
          description: "Creates an approval note",
        },
        {
          value: "togglePreAuthModal",
          name: "Approve with preauth",
          description:
            "Creates an approval note and asks if preauth is required",
        },
        {
          value: "addUnableToPickupNote",
          name: 'Add "Unable to pick up" note',
          description:
            "Creates a note stating that the equipment was unable to be picked up",
        },
        {
          value: "routeBackToSender",
          name: "Return to Sender",
          description: "Routes the ticket back to sender",
        },
        {
          value: "needsRedelivery",
          name: "Needs redelivery",
          description:
            "Clears Setup and delivery date, sets Needs Redelivery flag",
        },
        {
          value: "nonBillableCheck",
          name: "Override if non-billable",
          description:
            "Checks Service order products and delivered service parts, then routes to Non-billable Approved when none are billable",
        },
        {
          value: "createPickup",
          name: "Create Pickup Ticket",
          description: "Creates a Pickup Ticket after routing",
        },
      ],

      /**
       * This section is for new context entries that are now indexed by
       * their primary key. It may include some duplications of the above
       * data for backwards compatability.
       *
       * Nomenclature is the plural name of the object followed by the
       * word "indexed".
       *
       * Note that this should be limited to one entry per object type.
       * For example, do not use "allUsers" and "allActiveUsers". Those
       * distinctions should be handled with appropriate filtering.
       */
      updateIndexed: (key, data) => {
        this.setState((prevState) => ({
          [key]: {
            ...prevState[key],
            [data.id]: data,
          },
        }));
        window.sessionStorage.removeItem(key);
      },
      deleteIndexed: (key, id) => {
        this.setState((prevState) => {
          const { [id]: deleted, ...rest } = prevState[key];
          return { [key]: rest };
        });
        window.sessionStorage.removeItem(key);
      },
      setCurrentUser: (user) => {
        this.setState({ currentUser: user });
        window.sessionStorage.setItem("currentUser", JSON.stringify(user));
      },
      setCompanyName: (company) => {
        this.setState({ companyName: company });
        window.sessionStorage.setItem("companyName", JSON.stringify(company));
      },
      signaturesIndexed: {},
      termsIndexed: {},
      hcpcsCodesIndexed: {},
      distributionReasonsIndexed: {},
      userProductionTypesIndexed: {},
      usersIndexed: {},
      departmentsIndexed: {},
      teamsIndexed: {},
      teamUsersIndexed: {},
      teamQueuesIndexed: {},
      teamDashboardsIndexed: {},
      queueRoutesIndexed: {},
      queuesIndexed: {},
      orderActivityTypesIndexed: {},
      issueStatusesIndexed: {},
      orderStatusesIndexed: {},
      orderStatusReasonsIndexed: {},
      orderStatusReasonDetailsIndexed: {},
      insuranceTypesIndexed: {},
      insuranceSubTypesIndexed: {},
      serviceReasonsIndexed: {},
      baseUnitTypesIndexed: {},
      baseUnitsIndexed: {},
      vendorsIndexed: {},
      colorsIndexed: {},
      locationsIndexed: {},
      regionsIndexed: {},
      productTypesIndexed: {},
      productSubTypesIndexed: {},
      issueCategoriesIndexed: {},
      issueReasonsIndexed: {},
      organizationsIndexed: {},
      salesPcrLinksIndexed: {},
      marketingCampaignsIndexed: {},
      marketingCampaignCategoriesIndexed: {},
      userprofileLocationsIndexed: {},
      accountTypesIndexed: {},
      contactTypesIndexed: {},
      documentTypesIndexed: {},
      creditCardTypesIndexed: {},
      expenseTypesIndexed: {},
      servicePartCatalogsIndexed: {},
      feeSchedulesIndexed: {},
      modifierCodesIndexed: {},
      permissionsIndexed: {},
      rolesIndexed: {},
      rolePermissionsIndexed: {},
      userprofilePermissionsIndexed: {},
      userprofileRolesIndexed: {},
      dashboardsIndexed: {},
      widgetsIndexed: {},
      dashboardWidgetsIndexed: {},
      newVersionAvailable: false,
      manifestVersion: null,
    };

    // Check for a new version of the app by parsing meta.json on the server.
    const checkForUpdate = async () => {
      try {
        const response = await fetch("/manifest.json", { cache: "no-store" });
        const manifest = await response.json();

        if (manifest.version) {
          if (
            window.salesPilot.meta.version.localeCompare(
              manifest.version,
              undefined,
              {
                numeric: true,
                sensitivity: "base",
              },
            ) < 0
          ) {
            if (new URL(window.location).pathname === "/") {
              // If you're on the login screen when an update hits, force a reload.
              window.location.reload();
            } else {
              this.setState({
                newVersionAvailable: true,
                manifestVersion: manifest.version,
              });
            }
          }
        }
      } catch (e) {
        // For some reason this fetch fails a lot. Not sure if it's just
        // because it's happening right on page load or what. For now
        // ignoring errors. If this check does not fix the version lag
        // we're seeing I'll re-enable the exception here and deal with
        // it. - JZ
      }
    };

    const checkForInactivity = () => {
      if (
        window.salesPilot.meta.environment === "production" &&
        moment().diff(
          moment(Setting.get("meta.lastActivity", false)),
          "minutes",
        ) > 60 &&
        new URL(window.location).pathname !== "/"
      ) {
        Setting.clear("session", window.sessionStorage);
        Setting.clear("session", window.localStorage);
        Setting.set(
          "loginError",
          "You have been logged out due to inactivity.",
        );
        Setting.set(
          "loginErrorExpiration",
          moment().add(1, "hour").toISOString(),
        );
        window.sessionStorage.clear();
        window.location.href = "/";
      }
    };

    // Check for updates every hour
    if (!window.checkForUpdateInterval) {
      window.checkForUpdateInterval = window.setInterval(
        checkForUpdate,
        3600000,
      );
      checkForUpdate();
    }

    // Check for inactivity every minute
    if (!window.checkForInactivityInterval) {
      window.checkForInactivityInterval = window.setInterval(
        checkForInactivity,
        60000,
      );
    }

    // Global Ctrl+K listener for navigation dialog
    this.handleGlobalKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        if (this.state.loaded) {
          this.setState({ navigationOpen: true });
        }
      }
    };
    window.addEventListener("keydown", this.handleGlobalKeyDown);
  }

  setContextItem(key, value) {
    this.setState({
      [key]: value,
    });
  }

  componentWillUnmount() {
    if (this.handleGlobalKeyDown) {
      window.removeEventListener("keydown", this.handleGlobalKeyDown);
    }
  }

  render() {
    const hideAppBar =
      this.props.location &&
      typeof this.props.location.pathname === "string" &&
      this.props.location.pathname.startsWith("/file/");
    // Prepare context value object
    const contextValue = {
      ...this.state,
      setContextItem: this.setContextItem.bind(this),
    };

    return (
      <MUILocalizationProvider dateAdapter={MUIAdapterMoment}>
        <NotistackSnackbarProvider
          autoHideDuration={5000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          maxSnack={3}
        />
        <MainProvider value={contextValue}>
          <div
            className="flyout App-background mainBackground"
            style={{
              backgroundSize: "cover",
              backgroundAttachment: "fixed",
              backgroundImage: `url(${background})`,
            }}
          >
            {!hideAppBar && this.state.loaded && this.renderAppBar()}

            <main
              style={{
                marginTop: this.state.loaded && !hideAppBar ? "50px" : "0",
              }}
            >
              <Routes />
            </main>

            {this.state.loaded && this.renderInventoryRequestModal()}
            {this.state.loaded && this.renderPODeliveryUpdateModal()}
          </div>
          {this.state.loaded && this.renderNewVersionSnackbar()}
        </MainProvider>
      </MUILocalizationProvider>
    );
  }

  renderAppBar() {
    const handleOnSearchChange = (orderId) => {
      this.setState({
        orderId: orderId,
      });
    };

    const handleCloseDialog = () => {
      this.setState({
        inventoryRequestOpen: false,
        poDeliveryUpdateOpen: false,
      });
    };

    return (
      <AppBar
        onChange={handleOnSearchChange.bind(this)}
        /** TODO: Refactor InventoryRequestModal && PODeliveryUpdateModal
         * into a SP Component and import
         * components directly inside of AppBar. Keeping the logic in
         * this file for now due to the complexity of refactoring.
         */
        onCloseDialog={handleCloseDialog.bind(this)}
        modalOpen={
          this.state.inventoryRequestOpen === true ||
          this.state.poDeliveryUpdateOpen === true
        }
        openInventoryRequestModal={() =>
          this.setState({ inventoryRequestOpen: true })
        }
        openPODeliveryUpdateModal={() =>
          this.setState({ poDeliveryUpdateOpen: true })
        }
      />
    );
  }

  renderNewVersionSnackbar() {
    return (
      <MUISnackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.state.newVersionAvailable}
      >
        <MUIAlert
          severity="info"
          variant="filled"
          action={
            <MUIButton
              color="inherit"
              size="small"
              onClick={() => {
                window.location.reload();
              }}
            >
              FINISH UPDATE
            </MUIButton>
          }
        >{`Sales Pilot ${this.state.manifestVersion} available.`}</MUIAlert>
      </MUISnackbar>
    );
  }

  closeInventoryRequest() {
    this.setState({
      inventoryRequestOpen: false,
    });
  }

  renderInventoryRequestModal() {
    return (
      <MDBModal
        fullWidth={true}
        maxWidth={"lg"}
        isOpen={this.state.inventoryRequestOpen}
        toggle={() => {
          this.setState({
            inventoryRequestOpen: false,
          });
        }}
        slotProps={{
          paper: {
            sx: { overflow: "visible" },
          },
        }}
      >
        <InventoryRequest onClose={this.closeInventoryRequest.bind(this)} />
      </MDBModal>
    );
  }

  renderPODeliveryUpdateModal() {
    return (
      <MDBModal
        fullWidth={true}
        maxWidth={"sm"}
        isOpen={this.state.poDeliveryUpdateOpen}
        toggle={() => {
          this.setState({
            poDeliveryUpdateOpen: false,
          });
        }}
      >
        <PODeliveryUpdate onClose={this.closePODeliveryUpdate.bind(this)} />
      </MDBModal>
    );
  }

  closePODeliveryUpdate() {
    this.setState({
      poDeliveryUpdateOpen: false,
    });
  }
}

export default withRouter(App);
